import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    referralCode: "",
  });
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const errors = {};
    if (form.username.length < 6 || form.username.length > 25)
      errors.username = "Username must be between 6 and 25 characters.";
    if (form.password.length < 6 || form.password.length > 32)
      errors.password = "Password must be between 6 and 32 characters.";
    if (form.password !== form.confirmPassword)
      errors.confirmPassword = "Passwords do not match.";
    if (!form.firstName.trim()) errors.firstName = "First name required.";
    if (!form.lastName.trim()) errors.lastName = "Last name required.";
    if (!form.referralCode.trim()) errors.referralCode = "Referral required.";

    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const res = await fetch("https://api.backofficemain.com/register_user.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: form.username,
          password: form.password,
          firstname: form.firstName,
          lastname: form.lastName,
          referral: form.referralCode,
        }),
      });
      const data = await res.json();
      if (data.success) {
        alert("Registration successful!");
        navigate("/login");
      } else {
        alert(data.message || "Registration failed.");
      }
    } catch (err) {
      console.error(err);
      alert("Error connecting to the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{
        background: "linear-gradient(135deg, #ff1744, #e91e63)",
        color: "#fff",
      }}
    >
      <div
        className="card shadow-lg p-4 border-0"
        style={{ width: "400px", borderRadius: "20px" }}
      >
        <div className="text-center mb-3">
          <h3 className="fw-bold text-danger">Create Account</h3>
          <p className="text-muted">Join the NetflixVIP community</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label text-dark">Username</label>
            <input
              type="text"
              name="username"
              className={`form-control ${error.username ? "is-invalid" : ""}`}
              value={form.username}
              onChange={handleChange}
            />
            {error.username && (
              <div className="invalid-feedback">{error.username}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label text-dark">Password</label>
            <input
              type="password"
              name="password"
              className={`form-control ${error.password ? "is-invalid" : ""}`}
              value={form.password}
              onChange={handleChange}
            />
            {error.password && (
              <div className="invalid-feedback">{error.password}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label text-dark">Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              className={`form-control ${
                error.confirmPassword ? "is-invalid" : ""
              }`}
              value={form.confirmPassword}
              onChange={handleChange}
            />
            {error.confirmPassword && (
              <div className="invalid-feedback">{error.confirmPassword}</div>
            )}
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label text-dark">First Name</label>
              <input
                type="text"
                name="firstName"
                className={`form-control ${error.firstName ? "is-invalid" : ""}`}
                value={form.firstName}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-dark">Last Name</label>
              <input
                type="text"
                name="lastName"
                className={`form-control ${error.lastName ? "is-invalid" : ""}`}
                value={form.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label text-dark">Referral Code</label>
            <input
              type="text"
              name="referralCode"
              className={`form-control ${
                error.referralCode ? "is-invalid" : ""
              }`}
              value={form.referralCode}
              onChange={handleChange}
            />
          </div>

          <button
            type="submit"
            className="btn btn-danger w-100 py-2 fw-bold"
            disabled={loading}
          >
            {loading ? "Registering..." : "REGISTER"}
          </button>
        </form>

        <p
          className="mt-3 text-center text-muted"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/login")}
        >
          Already have an account?{" "}
          <span className="text-danger fw-semibold">Login Now</span>
        </p>
      </div>
    </div>
  );
}
